import { applyMiddleware, createStore, compose } from 'redux';
import {thunk} from 'redux-thunk';
import appReducer from '../reducers';

const configureStore = preloadedState =>
  createStore(appReducer, preloadedState, compose(applyMiddleware(thunk)));

export default configureStore;
